export default __webpack_public_path__ + "static/media/bb_w.bdf64d1b.png";